<template>
  <div class="mit-maps-page mit-page">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Manage People 2</v-card-title>
            <v-card-subtitle class="caption">Search for lab members</v-card-subtitle>
            <v-divider></v-divider>
            <MitManagePeopleList2 />
            <v-card-text>
              <!-- Additional content can go here if needed -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import MitManagePeopleList2 from '../../components/manage/MitManagePeopleList2.vue'; 

export default {
  name: 'MitHRManagePeoplePage2',
  components: {
    MitManagePeopleList2, 
  },
  data() {
    return {
      
    };
  },
  created() {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.mit-info-card {
  width: 100%;
  height: 100%;
}
</style>
